<!--<div class="row">
  <div style="text-align:center">
    <h1><i class="fa fa-address-card"></i> Clery Compliance Admin</h1>
  </div>
</div>
<div class="row">
  <div class="col-md-3">
    <img src="~/../images/TTUS_seal.svg.png" style="width: 100%" />
  </div>
  <div class="col-md-9">
    <div class="row">&nbsp;</div>
    <div class="row">&nbsp;</div>
    <div class="row">&nbsp;</div>
    <div class="row">&nbsp;</div>
    <div class="row">
      <div class="col-md-4 ttCellAlignCenter"><button class="btn btn-lg btn-danger ttBtn" (click)="setInstitution('TTU')">Texas Tech University</button></div>
      <div class="col-md-4 ttCellAlignCenter"><button class="btn btn-lg btn-danger ttBtn" (click)="setInstitution('HSC')">Texas Tech University<br />Health Sciences Center</button></div>
      <div class="col-md-4 ttCellAlignCenter"><button class="btn btn-lg btn-danger ttBtn" (click)="setInstitution('HSCE')">Texas Tech University<br />Health Sciences Center<br />El Paso</button></div>
    </div>
    <div class="row">&nbsp;</div>
    <div class="row">&nbsp;</div>
    <div class="row">&nbsp;</div>
    <div class="row">
      <div class="col-md-2">&nbsp;</div>
      <div class="col-md-4 ttCellAlignCenter"><button class="btn btn-lg btn-primary asuBtn" (click)="setInstitution('ASU')">Angelo State University</button></div>
      <div class="col-md-4 ttCellAlignCenter"><button class="btn btn-lg btn-danger msuBtn" disabled (click)="setInstitution('MSU')">Midwestern State<br />University</button></div>
      <div class="col-md-2">&nbsp;</div>
    </div>
  </div>
</div>

<div *ngIf="institutionBtn != ''">
  <div class="row">
    <div style="text-align:center">
      <h1>{{institutionTitle}}</h1>
    </div>
  </div>
  <div class="row">&nbsp;</div>
  <div class="row">&nbsp;</div>
  <div class="row">
    <div *ngFor="let il of InstitutionLinks; let i = index">
      <div class="col-md-2" *ngIf="i < 6">
        <div *ngIf="InstitutionLinks[i].status == 'A'">
          <a href="{{il.link}}?inst={{il.institution}}"><button class="btn btn-lg {{institutionBtn}}">{{il.title}}</button></a>
        </div>
        <div *ngIf="InstitutionLinks[i].status == 'I'">
          <button class="btn btn-lg {{institutionBtn}}" disabled>{{il.title}}</button>
        </div>
      </div>
    </div>
  </div>
  <div class="row">&nbsp;</div>
  <div class="row">&nbsp;</div>
  <div class="row">
    <div *ngFor="let il of InstitutionLinks; let i = index">
      <div class="col-md-2" *ngIf="i > 5">
        <div *ngIf="InstitutionLinks[i].status == 'A'">
          <a href="{{il.link}}"><button class="btn btn-lg {{institutionBtn}}">{{il.title}}</button></a>
        </div>
        <div *ngIf="InstitutionLinks[i].status == 'I'">
          <button class="btn btn-lg {{institutionBtn}}" disabled>{{il.title}}</button>
        </div>
      </div>
    </div>
  </div>
</div>-->
Hello World
